import { DisplayPageType } from "@faire/web-api--source/indigofair/data/DisplayPageType";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import {
  QueryParameters as BrandPageQueryParameters,
  path as brandPage,
} from "@faire/web-api--source/routes/brand/brandToken";
import {
  QueryParameters as ProductPageQueryParameters,
  path as productPage,
} from "@faire/web-api--source/routes/product/productToken";
import { useCallback } from "react";
import { useRouteMatch } from "react-router-dom";

import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { getQueryParamsForSurface } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/tileUrlHelpers";

export const useGenerateProductLinkPropsForSDUIProductTileHandler = (
  productTile: ILeanProductTile | undefined,
  display_page?: keyof typeof DisplayPageType
) => {
  const location = useZustandLocation((state) => state.search);
  const match = useRouteMatch();

  return useCallback(() => {
    const product = productTile?.product;
    if (!product?.token) {
      return undefined;
    }

    const productPageParams = ProductPageQueryParameters.build({
      productOptionToken: productTile?.selected_product_option_token,
      impressionId: product.impression_id,
    });

    if (display_page !== undefined) {
      const queryParams = getQueryParamsForSurface(
        display_page,
        location,
        match
      );
      productPageParams.refF = queryParams.refF;
      productPageParams.refC = queryParams.refC;
    }
    return {
      productUrl: productPage(product.token, productPageParams),
    };
  }, [display_page, match, location, productTile]);
};

export const useGenerateBrandUrlForSDUIProductTileHandler = (
  productTile: ILeanProductTile | undefined,
  display_page?: keyof typeof DisplayPageType
) => {
  const location = useZustandLocation((state) => state.search);
  const match = useRouteMatch();

  return useCallback(() => {
    const product = productTile?.product;
    const brandToken = product?.brand_token;
    if (!brandToken) {
      return undefined;
    }

    const brandPageParams = BrandPageQueryParameters.build({
      refP: product.token,
      impressionId: product.impression_id,
    });

    if (display_page !== undefined) {
      const queryParams = getQueryParamsForSurface(
        display_page,
        location,
        match
      );
      brandPageParams.refF = queryParams.refF;
      brandPageParams.refC = queryParams.refC;
      brandPageParams.sortingHint = queryParams.sortingHint;
    }
    return brandPage(brandToken, brandPageParams);
  }, [display_page, match, location, productTile]);
};
